var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 3.96967C12.2374 3.67678 11.7626 3.67678 11.4697 3.96967C11.1768 4.26256 11.1768 4.73744 11.4697 5.03033L12.1893 5.75H6C4.20507 5.75 2.75 7.20507 2.75 9V9.5C2.75 9.91421 3.08579 10.25 3.5 10.25C3.91421 10.25 4.25 9.91421 4.25 9.5V9C4.25 8.0335 5.0335 7.25 6 7.25H12.1893L11.4697 7.96967C11.1768 8.26256 11.1768 8.73744 11.4697 9.03033C11.7626 9.32322 12.2374 9.32322 12.5303 9.03033L14.5303 7.03033C14.8232 6.73744 14.8232 6.26256 14.5303 5.96967L12.5303 3.96967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 11C15.75 11.9665 14.9665 12.75 14 12.75L7.81066 12.75L8.53033 12.0303C8.82322 11.7374 8.82322 11.2626 8.53033 10.9697C8.23744 10.6768 7.76256 10.6768 7.46967 10.9697L5.46967 12.9697C5.17678 13.2626 5.17678 13.7374 5.46967 14.0303L7.46967 16.0303C7.76256 16.3232 8.23744 16.3232 8.53033 16.0303C8.82322 15.7374 8.82322 15.2626 8.53033 14.9697L7.81066 14.25L14 14.25C15.7949 14.25 17.25 12.7949 17.25 11V10.5C17.25 10.0858 16.9142 9.75 16.5 9.75C16.0858 9.75 15.75 10.0858 15.75 10.5V11Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/Recurring.e1e2a570e1d4cc2d778a5dd0f9bb5f77.svg";
export { ForwardRef as ReactComponent };